import * as React from 'react';
import Label from './components/Label';
import Group from './components/Group';
import Input from './components/Input';

interface FormProps {
  className?: string;
  style?: any;
  onSubmit: () => void;
  children?: React.ReactNode[] | React.ReactNode;
}

const Form = ({ className, style, onSubmit, children }: FormProps) => {
  return (
    <form className={className} style={style} onSubmit={onSubmit}>
      {children}
    </form>
  );
};

Form.Label = Label;
Form.Group = Group;
Form.Input = Input;

export default Form;
